import {
  RangeControl,
  ToggleControl,
  __experimentalNumberControl as NumberControl,
  SelectControl,
} from '@wordpress/components';

const {
  i18n: { __ },
} = wp;

const SliderControl = (props) => {
  const {
    attributeName,
    inputFieldTypes,
    sliderSettingsField: field,
    deviceSlug,
    setSliderSettingAttribute,
  } = props;
  let element = null;
  const {
    type: fieldType,
    value: fieldValue,
    name: fieldName,
    onChange: fieldOnChange,
    label: fieldLabel,
    valueFormatter: valueFormatter,
    step: fieldStep,
  } = field;

  const inputValue = valueFormatter ? valueFormatter(fieldValue) : fieldValue;

  const onChange = (newValue) => {
    // eslint-disable-next-line no-unused-expressions
    fieldOnChange
      ? fieldOnChange(deviceSlug, newValue)
      : setSliderSettingAttribute(
          attributeName,
          deviceSlug,
          fieldName,
          '',
          newValue,
        );
  };

  switch (fieldType) {
    case inputFieldTypes.Range:
      element = (
        <RangeControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          min={field.min}
          max={field.max}
          value={inputValue}
          step={fieldStep ? fieldStep : 1}
          onChange={onChange}
        />
      );
      break;

    case inputFieldTypes.Toggle:
      element = (
        <ToggleControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          checked={inputValue}
          onChange={onChange}
        />
      );
      break;

    case inputFieldTypes.Number:
      element = (
        <NumberControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          isShiftStepEnabled={typeof field.step === 'number'}
          onChange={onChange}
          max={field.max}
          min={field.min}
          value={inputValue}
          step={fieldStep}
        />
      );
      break;

    case inputFieldTypes.Select:
      element = (
        <SelectControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(field.label, 'b3rg')}
          value={inputValue}
          options={field.options}
          onChange={onChange}
        />
      );
      break;

    default:
      break;
  }

  return element;
};

export default SliderControl;
